import { Transform, Type } from "class-transformer";

import { capitalize } from "../../shared/tool-functions/capitalize";

import { ThematicCategory } from "./category.model";
import { CreateDynamic, Dynamic } from "./dynamic.model";
import { KeyNumber } from "./key-number.model";
import { Pillar } from "./pillar.model";
import { Testimonial } from "./testimonial.model";

export interface IThematic {
  id: string;
  name: string;
  dynamics: Dynamic[];
  title: string;
  resume: string;
  workingOn: string;
  slug: string;
  testimonials?: Testimonial[];
  /** @deprecated Use pillar instead */
  category?: ThematicCategory;
  pillar?: Pillar;
  keyNumbers?: KeyNumber[];
  /** IDs of pinned contents for this thematic (max 3) */
  pinnedContentIds?: string[];
  translationMissing?: boolean;
}

export class Thematic implements IThematic {
  id!: string;

  @Transform(({ value }) => capitalize(value))
  name!: string;

  slug!: string;

  @Type(() => Dynamic)
  dynamics!: Dynamic[];

  testimonials?: Testimonial[];

  /** @deprecated Use pillar instead */
  category?: ThematicCategory;

  pillar?: Pillar;

  keyNumbers?: KeyNumber[];

  @Transform(({ value }) => capitalize(value))
  title!: string;

  resume!: string;

  workingOn!: string;

  imageUrl!:string;

  detailsImageUrl!:string;

  isEnabled!: boolean;

  isArchived?: boolean;

  /** IDs of pinned contents for this thematic (max 3) */
  pinnedContentIds?: string[];

  translationMissing?: boolean;
}

export type CreateTestimonial = {
  author: string;
  description: string;
}

export type CreateKeyNumber = {
  stringNumber: string;
  description: string;
}


export type CreateThematic = {
  slug: string;
  name: string;
  title: string;
  resume: string;
  workingOn: string[];
  pillar: string;
  dynamics: CreateDynamic[];
  testimonials: CreateTestimonial[];
  keyNumbers: CreateKeyNumber[];
  /** IDs of pinned contents for this thematic (max 3) */
  pinnedContentIds?: string[];
}

export type CreateThematicForm = {
  slug: string;
  name: string;
  title: string;
  resume: string;
  pillar: string;
  speech: boolean;
  coaching: boolean;
}

export type CreateThematicWithFile = CreateThematic & {
  file?: File,
}

